import { forwardRef } from 'react'
import {
	categoryFormatToLabel,
	categoryToLabel
} from '@/features/experience-shell/utils'
import type { RemapExperienceForViewOnly } from '@/features/experience-view-only/types'
import { useTranslation } from '@/translations/i18n'
import { AnswerField, Content } from './atoms'

export const ExperienceStep = forwardRef<
	HTMLDivElement,
	{ experience: RemapExperienceForViewOnly }
>(({ experience }, ref) => {
	const { t } = useTranslation()
	const category = experience.category.category?.keyName
	const format = experience.category.subCategory?.keyName

	return (
		<Content ref={ref} title={t('experience_shell:step_experience')}>
			<AnswerField
				hasValue={!!category && category !== 'generic'}
				labelTitle={t('experience_shell:category')}
				value={
					category && category !== 'generic'
						? t(
								categoryToLabel[
									category as keyof typeof categoryToLabel
								]
							)
						: undefined
				}
			/>
			<AnswerField
				hasValue={!!format}
				labelTitle={t('experience_shell:format')}
				value={format ? t(categoryFormatToLabel[format]) : undefined}
			/>
		</Content>
	)
})

ExperienceStep.displayName = 'ExperienceStep'
